<template>
  <section class="pt-5 pb-16 tablet:pt-16">
    <div class="grid-container">
      <div class="col-span-12 grid gap-x-4 gap-y-6 laptop:grid-cols-3">
        <div v-for="({ img, heading, description }, idx) in facts" :key="`fact_${idx}`" class="text-center">
          <img :src="img" :alt="heading" class="mx-auto" />

          <h4 class="mb-4 text-headline-s">{{ heading }}</h4>

          <p>{{ description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import ConnectImg from '@/assets/images/landing/connect.png'
import ReachImg from '@/assets/images/landing/reach.png'
import RockNRollImg from '@/assets/images/landing/rocknroll.png'

import { useNuxtApp } from '#imports'

const { $i18n } = useNuxtApp()

const facts = computed(() => [
  {
    img: ConnectImg,
    heading: $i18n.t('new_job_landing.facts.heading_1'),
    description: $i18n.t('new_job_landing.facts.description_1'),
  },
  {
    img: ReachImg,
    heading: $i18n.t('new_job_landing.facts.heading_2'),
    description: $i18n.t('new_job_landing.facts.description_2'),
  },
  {
    img: RockNRollImg,
    heading: $i18n.t('new_job_landing.facts.heading_3'),
    description: $i18n.t('new_job_landing.facts.description_3'),
  },
])
</script>
